import React from 'react'
import { makeStyles, Icon } from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.secondary.main,
  },
}))

const NotificationPreviewActions = ({ notification }) => {
  const classes = useStyles()
  return (
    <div className="flex justify-between w-full">
      {notification.allowConversation && (
        <div className="flex w-64 h-48 justify-center items-center">
          <Icon className={classes.icon} fontSize="small">
            <img
              alt="chat"
              className="flex w-16 h-16 mt-1"
              src={Assets.conversation.chatIcon}
            />
          </Icon>
        </div>
      )}
      <div className="flex w-64 h-48 justify-center items-center">
        <Icon className={classes.icon} fontSize="small">
          bookmark_border
        </Icon>
      </div>
      <div className="flex w-64 h-48 justify-center items-center">
        <img
          alt="calendar"
          className="flex w-16 h-16"
          src={Assets.notiPreviewCard.heart}
        />
      </div>
      <div className="flex w-64 h-48 justify-center items-center">
        <img
          alt="calendar"
          className="flex w-16 h-16"
          src={Assets.notiPreviewCard.calendar}
        />
      </div>
      <div className="flex w-64 h-48 justify-center items-center">
        <Icon className={classes.icon}>more_horiz</Icon>
      </div>
    </div>
  )
}

export default NotificationPreviewActions
